<template>
  <div class="diseaseList">
    <!-- 开户按钮 -->
    <el-form :inline="true" size="small">
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin-right:20px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80vh">
      <el-table
        :data="dataList"
        style="width: 100%"
        height="100%"
        border
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="正在加载中"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column label="展会" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.exhibitionID == 1 ? "茶博会" : "食品展" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="登记时间"
          width="180"
          align="center"
          prop="createTime"
          sortable
        ></el-table-column>
        <el-table-column label="公司名" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.company }}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          width="130"
          align="center"
          prop="phone"
        ></el-table-column>
        <el-table-column label="邮箱" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.email ? scope.row.email : "/" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="展馆" width="250" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pavilion ? scope.row.pavilion : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="需要标准(个)" width="130" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.mianji }}</span>
          </template>
        </el-table-column>
        <el-table-column label="需要特装面积" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.vipMianji ? scope.row.vipMianji : "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否需搭建服务" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.dajian ? "需要" : "不需要" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="参展内容" width="250" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.content ? scope.row.content : "/" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="给主办方留言"
          width="220"
          align="center"
          prop="message"
        ></el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteBtn(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  selectBookingBooth,
  deleteBookingBooth,
} from "@/services/supAdmin/teaData/index.js";
export default {
  data() {
    return {
      downloadLoading: false,
      dataList: [],
      supplierPhone: "",
      phone: "",
      cardNumber: "",
      loading: false,
      name: "",
      pageCount: "",
      pageSize: 8,
      adminArr: [
        { name: "最高权限", id: 1 },
        { name: "普通子账号权限", id: 2 },
      ],
      form: {},
      dialogFormVisible: false,
    };
  },
  created() {
    this.select();
  },
  methods: {
    select() {
      // 查询数据
      this.loading = true;
      selectBookingBooth().then((res) => {
        console.log(res);
        this.dataList = res.data;
        this.loading = false;
      });
    },
    // 删除
    deleteBtn(row) {
      console.log("----------删除------------", row);
      // this.$message.error('暂未开启该权限')
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row.id);
          deleteBookingBooth(row.id).then((res) => {
            console.log(res);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "时间",
          "姓名",
          "手机号",
          "公司",
          "邮箱",
          "标准展位(个)",
          "特装展位(面积)",
          "参展内容",
          "留言",
          "是否需要搭建(0不需要,1需要)",
        ];
        const filterVal = [
          "createTime",
          "name",
          "phone",
          "company",
          "email",
          "mianji",
          "vipMianji",
          "content",
          "message",
          "dajian",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "展商登记数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 100%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.userNanme:hover {
  cursor: pointer;
}
</style>
